import { DataType, ListType, MetadataColumn, RequiredData, UiTextEnum } from '@bechtel/sr-types';
import { useLanguage } from '~/components';
import { getDataType } from '~/utilities';

interface YupSchemaProps {
  metadataColumns: MetadataColumn[] | undefined;
  requiredCondition?: (item: MetadataColumn) => boolean;
  tagIsRequired?: boolean;
}

export const useYupSchema = ({
  metadataColumns,
  requiredCondition = () => false,
  tagIsRequired = true,
}: YupSchemaProps) => {
  const { isAlternateLanguageUsed, getMultiLingualTextByKey } = useLanguage();

  const generateSchema = () => {
    let schema;
    metadataColumns &&
      metadataColumns.map((item) => {
        const metaDataColumn = item.displayColumn ? item.displayColumn : item;
        let individualSchema;
        if (item.isUserEditable) {
          const columnDescription = (isAlternateLanguageUsed ? item.alternateDescription : item.description) ?? '';
          individualSchema = getDataType(metaDataColumn && metaDataColumn.dataType ? metaDataColumn.dataType : '');
          const isRequired =
            (item.requiredData as RequiredData) > RequiredData.NO ||
            (item?.pickListType as ListType) > RequiredData.YES ||
            (tagIsRequired && item.memberName === 'tag') ||
            requiredCondition(item);
          individualSchema = isRequired
            ? individualSchema.required(getMultiLingualTextByKey(UiTextEnum.VALUE_CANNOT_BE_BLANK, [columnDescription]))
            : individualSchema.nullable(true);
          const isNumber = metaDataColumn.dataType === DataType.NUMBER;
          if (isNumber) {
            individualSchema = individualSchema
              .min(
                metaDataColumn.minValue,
                getMultiLingualTextByKey(UiTextEnum.VALUE_OUT_OF_RANGE, [
                  columnDescription,
                  String(metaDataColumn.minValue),
                  String(metaDataColumn.maxValue),
                ])
              )
              .max(
                metaDataColumn.maxValue,
                getMultiLingualTextByKey(UiTextEnum.VALUE_OUT_OF_RANGE, [
                  columnDescription,
                  String(metaDataColumn.minValue),
                  String(metaDataColumn.maxValue),
                ])
              );
          }
          if (isRequired || isNumber) {
            const temp = { [item.memberName as string]: individualSchema };
            schema = { ...schema, ...temp };
          }
        }
      });
    return schema;
  };

  return generateSchema;
};
